import { toast } from 'react-toastify'
import Api from './api'

function vcfText({
  prefix,
  firstName,
  lastName,
  organisationName,
  email,
  phone,
  phones,
  jobTitle,
  photo,
  companyURL,
  linkedInURL,
  socials,
  addresses,
  personalAccount,
}) {
  const getFullName = () => {
    if (prefix) return prefix + ' ' + firstName + ' ' + lastName
    return firstName + ' ' + lastName
  }

  const getName = () => {
    if (prefix) return `${lastName};${firstName};;${prefix};`
    return `${lastName};${firstName};;;`
  }

  const filterArray = () => {
    const seenValues = {}

    for (const item of phones) {
      const value = item.value

      if (!seenValues[value]) {
        seenValues[value] = true
        vcfPhones.push(item)
      }
    }
  }

  let vcfPhones = []
  if (phones) filterArray()
  if (
    phone &&
    !vcfPhones.find((item) => item.value == phone) &&
    !phone.includes('undefined')
  )
    vcfPhones.push({ label: 'WORK', value: phone })

  let str = `BEGIN:VCARD
VERSION:3.0
ORG:${organisationName}
FN:${getFullName()}
N:${getName()}
TITLE:${jobTitle}
EMAIL;TYPE=:${email}
PHOTO;VALUE=URL;TYPE=JPEG:${photo}
URL:${companyURL || ''}`

  if (personalAccount)
    str = str + `\nURL;TYPE=Saved via Cardly:https://www.cardlysa.com`

  if (linkedInURL) str = str + `\nX-SOCIALPROFILE;TYPE=linkedin:${linkedInURL}`

  if (socials)
    socials.forEach(({ type, value }) => {
      str = str + `\nX-SOCIALPROFILE;TYPE=${type || 'social'}:${value}`
    })

  if (addresses)
    addresses.forEach(({ type, value }) => {
      str = str + `\nADR;TYPE=${type || 'WORK'}:;;${value}`
    })

  // if (phone) str = str + `\nTEL:${phone}`;

  if (vcfPhones)
    vcfPhones.forEach(({ type, value }) => {
      if (value.includes('undefined')) return
      str = str + `\nTEL;TYPE=${type || 'WORK'}:${value}`
    })

  str = str + `\nEND:VCARD`

  return str
}
function getLuminance(color) {
  const r = parseInt(color.slice(1, 3), 16)
  const g = parseInt(color.slice(3, 5), 16)
  const b = parseInt(color.slice(5, 7), 16)

  return (0.299 * r + 0.587 * g + 0.114 * b) / 255
}
function getContrastRatio(color1, color2) {
  const luminance1 = getLuminance(color1)
  const luminance2 = getLuminance(color2)

  const brighter = Math.max(luminance1, luminance2)
  const darker = Math.min(luminance1, luminance2)

  return brighter / (darker + 3)
}
function invertTextColor(background) {
  const textColor =
    getContrastRatio(background, '#000000') >
    getContrastRatio(background, '#FFFFFF')
      ? '#000000'
      : '#FFFFFF'
  return textColor
}

const showToastMessage = (message) => {
  toast(message, {
    position: toast.POSITION.TOP_CENTER,
  })
}

function convert({ file, width, height, type }) {
  return new Promise((resolve, reject) => {
    const allow = ['jpg', 'gif', 'bmp', 'png', 'jpeg', 'svg']
    try {
      if (
        file.name &&
        file.name.split('.').reverse()[0] &&
        allow.includes(file.name.split('.').reverse()[0].toLowerCase()) &&
        file.size &&
        file.type
      ) {
        const imageType = type || 'jpeg'
        const imgWidth = width || 500
        const imgHeight = height || 300
        const fileName = file.name
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (event) => {
          const img = new Image()
          img.src = event.target.result
          img.onload = () => {
            const elem = document.createElement('canvas')
            elem.width = imgWidth
            elem.height = imgHeight
            const ctx = elem.getContext('2d')
            ctx.globalCompositeOperation = 'destination-over'
            ctx.drawImage(img, 0, 0, imgWidth, imgHeight)
            ctx.canvas.toBlob(
              (blob) => {
                const file = new File([blob], fileName, {
                  type: `image/${imageType.toLowerCase()}`,
                  lastModified: Date.now(),
                })
                resolve(file)
              },
              `image/${type || 'jpeg'}`,
              1
            )
          }
          reader.onerror = (error) => reject(error)
        }
        // eslint-disable-next-line prefer-promise-reject-errors
      } else reject('File not supported!')
    } catch (error) {
      console.log('Error while image resize: ', error)
      reject(error)
    }
  })
}

const resizeImage = async ({ file, width, height }) =>
  convert({ file, width, height, type: 'png' })

const formateDate = (date) => {
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

const formateTime = (date) => {
  return new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
}

const isEmptyJSON = (json) => JSON.stringify(json) === '{}'

const CurrencyFormat = ({ amount = 0, currency }) => {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD', // Change this to your desired currency code
    minimumFractionDigits: 2,
  })
  return currencyFormatter.format(amount)
}

const UploadImage = ({ notify, file, desiredPath }) => {
  const form = new FormData()
  form.append('image', file, file.name)
  return Api('/utils/upload/image?desiredPath=' + desiredPath, 'post', {
    payload: form,
    notify,
  })
}

const getImageURL = (img) => {
  return typeof img == 'object' ? URL.createObjectURL(img) : img
}

const getPercent = ({ newNum = 0, oldNum = 0 }) => {
  const percentage = (((newNum - oldNum) / newNum) * 100).toFixed()

  if (percentage > 0) {
    return `+${percentage}%`
  }
  if (percentage < 0) {
    return `-${Math.abs(percentage)}%`
  }
  return `${percentage}%`
}

function getCurrentMillisecondsAsString() {
  return Date.now().toString();
}

export {
  vcfText,
  invertTextColor,
  showToastMessage,
  isEmptyJSON,
  formateDate,
  formateTime,
  CurrencyFormat,
  UploadImage,
  getImageURL,
  getPercent,
  resizeImage,
  getCurrentMillisecondsAsString,
}
